window.filterGlobalnewsContent = function() {
	var year = document.querySelector('#selected_year') ? document.querySelector('#selected_year').value : null;
	var month = document.querySelector('#selected_month') ? document.querySelector('#selected_month').value : null;
	var categoryElement = document.querySelector('#category_id');
	var categoryId = categoryElement ? categoryElement.value : null;
	var url = filterSubimitUrl;

	if (url === '') {
		return;
	}

	if (year && year > 0) {
		url += '/_' + year;
		if (month && month > 0) {
			url += '-' + ((month > 9) ? month : '0' + month);
		}
	}

	if (categoryId && categoryId > 0) {
		url += '/c' + categoryId;
	}

	window.location = url;
};
